import { render, staticRenderFns } from "./PricingView.vue?vue&type=template&id=38a07ec0&scoped=true"
import script from "./PricingView.vue?vue&type=script&lang=js"
export * from "./PricingView.vue?vue&type=script&lang=js"
import style0 from "./PricingView.vue?vue&type=style&index=0&id=38a07ec0&prod&scoped=true&lang=scss"
import style1 from "./PricingView.vue?vue&type=style&index=1&id=38a07ec0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a07ec0",
  null
  
)

export default component.exports